import React from "react";
import { DayPicker } from "react-day-picker";
import { toDate } from "../../utils/date";
function setTime(date, timestring) {
    const [hours, minutes, seconds] = timestring.split(":");
    date.setHours(hours || 0);
    date.setMinutes(minutes || 0);
    date.setSeconds(seconds || 0);
    return date;
}
function mergeRanges(range, time) {
    return {
        from: setTime(new Date(range.from.valueOf()), time.from),
        to: setTime(new Date(range.to.valueOf()), time.to),
    };
}
function convertTimeRange(timeRange) {
    return {
        from: toDate(timeRange.from),
        to: toDate(timeRange.to),
    };
}
export const Calendar = ({ numberOfMonths = 2, onChange, minDate, maxDate, timeRange, }) => {
    const convertedTimeRange = convertTimeRange(timeRange);
    const [range, setRange] = React.useState(convertedTimeRange);
    const [time, setTime] = React.useState({
        from: "00:00:00",
        to: "23:59:59",
    });
    React.useEffect(() => {
        if ((range === null || range === void 0 ? void 0 : range.from) &&
            range.to &&
            range.from.valueOf() === range.to.valueOf()) {
            setTime({
                from: "00:00:00",
                to: "23:59:59",
            });
        }
    }, [range]);
    React.useEffect(() => {
        if ((range === null || range === void 0 ? void 0 : range.to) && range.from) {
            onChange(mergeRanges(range, time));
        }
    }, [range, time]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "tnic-rdp", style: {
                height: "270px",
                display: "flex",
                justifyContent: "space-evenly",
            } },
            React.createElement(DayPicker, { navLayout: "around", hideWeekdays: true, showOutsideDays: true, mode: "range", numberOfMonths: numberOfMonths, selected: range, onSelect: setRange, defaultMonth: range === null || range === void 0 ? void 0 : range.from, disabled: {
                    after: maxDate,
                    before: minDate,
                } })),
        React.createElement("div", { style: {
                display: "flex",
                flex: 1,
                flexDirection: "row",
                justifyContent: "space-around",
                borderTop: "1px solid #ccc",
                alignItems: "center",
            } },
            React.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                } },
                "From:",
                React.createElement("input", { value: time.from, style: { paddingLeft: "0.5em" }, className: "tnic-input", type: "time", onChange: (e) => {
                        setTime(Object.assign(Object.assign({}, time), { from: e.target.value }));
                    } })),
            React.createElement("div", { style: {
                    display: "flex",
                    alignItems: "center",
                } },
                "To:",
                React.createElement("input", { value: time.to, style: { paddingLeft: "0.5em" }, className: "tnic-input", type: "time", onChange: (e) => {
                        setTime(Object.assign(Object.assign({}, time), { to: e.target.value }));
                    } })))));
};
//# sourceMappingURL=Calendar.js.map